export const blankUser = {
  id: undefined,
  name: "",
  surname: "",
  email: "",
  hospitalId: 0,
  isActive: true,
};

export const blankHospitalInfo = {
  name: "",
  streetAddress: "",
  cityName: "",
  cityPostcode: "",
  cityRegionName: "",
  phone1: "",
  phone2: "",
  email: "",
  website: "",
};

export const blankSurvey = {
  userName: "",
  userSurname: "",
  hospitalName: "",
  lastUpdate: "",
  status: null,
  answers: [],
  previousAnswers: [],
};

export const blankReviewRequest = {
  hospitalId: 0,
  survey: blankSurvey,
  gallery: [],
};

export const blankStatistics = {
  year: 0,
  hospitalId: 0,
  values: [],
};

export const blankOfferedAnswers = new Map([
  [1, [{ offeredAnswerText: "", selected: false }]],
]);

export const blankBirthPlan = {
  categories: [],
};
